module.exports = __webpack_public_path__ + "img/facilities-buttons-add.1c93b26e.svg";